import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import FormButton from "../../Utils/FormButton";
import {SUCCESS} from "../../../utils/constants";
import Notification from "../../Utils/Notification";

class AddAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            password: '',
            isLoading: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({ isLoading: true });

        axios
            .post('/api/editor', this.state)
            .then(() => {
                Notification({
                    type: SUCCESS,
                    message: 'Admin created successfully'
                })
                this.props.history.push('/admin/dashboard/admins');
            })
            .catch((e) => {
                Notification({
                    data: e
                })
            }).finally(() => {
                this.setState({ isLoading: false });
            });
    }

    render() {
        return (
            <section className="contact-wrapper">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="contact_form">
                                <h3 className="title">Add Admin</h3>
                                <div id="login">
                                    <div id="message" />
                                    <form
                                        method="post"
                                        name="loginform"
                                        id="loginform"
                                        onSubmit={this.handleSubmit}>
                                        <input
                                            type="hidden"
                                            name="csrf-token"
                                            value={window.Laravel.csrfToken}
                                        />
                                        <div className="row">
                                            <div className="col-12  form-group">
                                                <label>Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="name"
                                                    id="name"
                                                    required
                                                    value={this.state.name}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                            <div className="col-12  form-group">
                                                <label>Email</label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="example@example.com"
                                                    name="email"
                                                    id="email"
                                                    required
                                                    value={this.state.email}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                            <div className="col-12  form-group">
                                                <label>Password</label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    name="password"
                                                    id="password"
                                                    required
                                                    value={this.state.password}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                            <div className="submit-btn mt-0">
                                                <FormButton
                                                    isLoading={this.state.isLoading}
                                                />
                                                <Link to="/admin/dashboard/posts" className="btn btn-warning ml-1">
                                                    Return
                                                </Link>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(AddAdmin);
